module.exports = __webpack_public_path__ + "media/images/new/filter_by_elevation_laptop@2x-51cdf67fe0dc61839e8be3755182a6bc.png";